import React from 'react';

import { RouterProvider } from '@change/ds-core-ui';
import { PrimitivesProvider } from '@change/ds-primitives';

import { useNavigate } from '@change-corgi/core-react/router';

import { DSLink } from './components/DSLink';

type Props = { children: React.ReactNode };

// using a const because of a hook dep in the usePrimitive hook implementation
// TODO improve usePrimitive implementation to avoid this issue
const primitives = { a: DSLink };

export const DSPrimitivesProvider: React.FC<Props> = ({ children }: Props) => (
	<PrimitivesProvider primitives={primitives}>{children}</PrimitivesProvider>
);

export const DSRouterProvider: React.FC<Props> = ({ children }: Props) => {
	const navigate = useNavigate();
	return <RouterProvider navigate={navigate}>{children}</RouterProvider>;
};
